import React from "react";

import { RecognitionScore as RecognitionScoreComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

const RecognitionScore = () => {
    const { scoreData, isFetchingScore, isErrorScore } = useSessionDetailsContext();

    const isEmptyState =
        !isErrorScore &&
        (scoreData == null || scoreData.dataset == null || scoreData.title == null);

    if (isFetchingScore) {
        return <ContentLoader height="21.1875rem" />;
    }

    if (isErrorScore && !isFetchingScore) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:recognition-score:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="18.1875rem"
                />
            </ComponentWrapper>
        );
    }

    return <RecognitionScoreComponent data={scoreData} minHeight="15.3125rem" />;
};

export default RecognitionScore;
